export default {
    makeModel: data => ({
        header: `Запчасти на трицикл ${data.make} ${data.model}`,
        header_uk: `Запчастини на трицикл ${data.make} ${data.model}`,
    }),
};
  



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/tritsikl/templates.js